import BackToTop from './common/back-to-top';
import Drawer from './common/drawer';
import DrawerCart from './common/drawer-cart';
import DrawerQuickbuy from './common/drawer-quickbuy';
import DrawerSearch from './common/drawer-search';
import Cart from './common/cart';
import Megamenu from './common/megamenu';
import ProductForm from './common/product-form';
import ProductQuantity from './common/product-quantity';
import NavigationMobile from './common/navigation-mobile';
import Slider from './common/slider';
import StickyHeader from './common/sticky-header';
import VariantRadios from './common/variant-radios';
import VariantSelect from './common/variant-select';
import CustomTabs from './common/custom-tabs';

export {
    BackToTop,
    Cart,
    CustomTabs,
    Drawer,
    DrawerQuickbuy,
    DrawerCart,
    DrawerSearch,
    Megamenu,
    NavigationMobile,
    ProductForm,
    ProductQuantity,
    Slider,
    StickyHeader,
    VariantRadios,
    VariantSelect    
}

console.log('Check deployment now (temp message will be deleted)')
